import styled from 'styled-components';
import { DialogBody, LoadingMask, ModalDialog, StyledDialog, StyledLoadingMaskContent } from '@zillow/constellation';

// Override constellation padding and height adjustments to prevent double scrolling bars.
export const ModalWithFullHeightBody = styled(ModalDialog)`
  > ${StyledDialog} {
    height: 100%;
  }
  ${DialogBody} {
    :after {
      height: 0 !important;
    }
    height: 100%;
    padding: 0 !important;
  }
`;

export const BlockLoadingMask = styled(LoadingMask)`
  display: block;
`;

export const TallHeightLoadingMask = styled(BlockLoadingMask)`
  min-height: 70vh;
`;

export const FullHeightLoadingMask = styled(BlockLoadingMask)`
  height: 100%;

  > ${StyledLoadingMaskContent} {
    height: 100%;
  }
`;
